import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutopayTermsService } from './services/autopay-terms.service';
import { CommonModule } from '@angular/common';
import { FormCheckboxComponent } from '../forms/form-checkbox/form-checkbox.component';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-autopay-terms',
  templateUrl: './autopay-terms.component.html',
  styleUrl: './autopay-terms.component.scss',
  standalone: true,
  imports: [CommonModule, FormCheckboxComponent, ReactiveFormsModule, TranslateModule]
})
export class AutopayTermsComponent {
  @Input() formGroup: UntypedFormGroup;
  @Input() controlName: string;
  @Input() set paymentType(data: 'BLIK' | 'PAYMENT_CARD') {
    this._paymentType = data;

    this.autopayService.getAutopayTerms(this.paymentType).subscribe({
      next: value => {
        this.autopayTermsText = value.regulation;
      }
    })
  };

  get paymentType(): 'BLIK' | 'PAYMENT_CARD' {
    return this._paymentType;
  }

  termsChecked: boolean = false;
  autopayTermsText: string = '-';
  isExpanded: boolean = false;
  private _paymentType: 'BLIK' | 'PAYMENT_CARD' = 'BLIK';

  constructor(private autopayService: AutopayTermsService) {
    this.autopayService.getAutopayTerms(this.paymentType).subscribe({
      next: value => {
        this.autopayTermsText = value.regulation;
      }
    })
  }
}
